import MobileNavigationLanguage from './mobile-navigation-language';

class LayoutNavigationLanguage {
  constructor() {
    this.container = document.getElementsByClassName('navWrapper')[0];
    if (!this.container) {
      console.log('Navigation MenuWrapperLayout not found');

      return;
    }

    this.init();
  }

  init() {
    this.mobileNavigationLanguage = new MobileNavigationLanguage(this.container);
    this.navigationUL = document.querySelector('.header-one .nav-one ul.language-pages-nav');
    this.hasOpenLayout = false;
    this.attachEvents();
    this.stickyHeader();
  }

  attachEvents() {
    this.navigationUL.addEventListener('click', (ev) => {
      let el = DomHelper.getClickTarget(ev);

      if (!el.parentElement.classList.contains('link')) {
        ev.preventDefault();
        let menuLink = DomHelper.closest(el, '.main-nav', this.navigationUL);

        if (menuLink) {
          let subNavigation = menuLink.querySelector('.navItemLayout')

          if (subNavigation) {
            this.menuLinkClicked(menuLink);
          }
        }
      }
    });

    document.body.addEventListener('click', (ev) => {
      let el = DomHelper.getClickTarget(ev);

      var navContainer = DomHelper.closest(el, '.nav-container');
      var navDropdown = DomHelper.closest(el, '.navDropdown');

      if (!(navContainer || navDropdown)) {
        this.closeOpenLayout();
      }
    });

    window.addEventListener('scroll', () => {
      if (this.hasOpenLayout) {
        this.closeOpenLayout();
      }
    });
  }

  menuLinkClicked(menuLink) {
    var linkWasOpen = this.closeOpenLayout(menuLink);

    if (!linkWasOpen) {
      this.showLayout(menuLink);
    }
  }

  showLayout(menuLink) {
    let subNavigation = menuLink.querySelector('.navItemLayout')

    if (subNavigation) {
      this.hasOpenLayout = true;
      DomHelper.addClass('open', menuLink);
      DomHelper.addClass('navItemLayoutOpened', subNavigation);
      DomHelper.addClass('mainnav_overlay-visible', document.body);
    }
  }

  closeOpenLayout(menuLink) {
    let openedSubNavigation = this.navigationUL.querySelectorAll('.navItemLayoutOpened');
    this.hasOpenLayout = false;
    var linkWasOpen = false;

    openedSubNavigation.forEach((layout) => {
      DomHelper.removeClass('navItemLayoutOpened', layout);
    });

    var links = Array.prototype.slice.call(this.navigationUL.getElementsByClassName('open'));
    links.forEach((item) => {
      if (menuLink && menuLink == item) {
        linkWasOpen = true;
      }

      DomHelper.removeClass('open', item);
    });

    DomHelper.removeClass('mainnav_overlay-visible', document.body);
    this.hasOpenLayout = false;

    return linkWasOpen;
  }

  stickyHeader() {
    var header = document.getElementsByClassName('header-one')[0];

    if (!header) {
      return;
    }

    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 0) {
        DomHelper.addClass('sticky-header', document.body)
      } else {
        DomHelper.removeClass('sticky-header', document.body)
      }
    });
  }
}

export default LayoutNavigationLanguage;
